export default "__VITE_ASSET__42e65589__"